// ==========================================================
// SaturnRings — Homepage Scroll Experience JS
// ==========================================================
(function () {
  'use strict';

  // --------------- Loader ---------------
  const loaderEl  = document.getElementById('sr-loader');
  const loadFill  = document.getElementById('sr-loadFill');
  const loadPct   = document.getElementById('sr-loadPct');
  const loadLabel = document.getElementById('sr-loadLabel');
  const startBtn  = document.getElementById('sr-startBtn');
  const bgDim     = document.getElementById('sr-bgDim');

  let lottieAnim  = null;
  let lottieReady = false;
  let progress    = 0;

  function setProgress(p) {
    const clamped = Math.max(0, Math.min(100, p));
    progress = clamped;
    if (loadFill) loadFill.style.width = clamped.toFixed(0) + '%';
    if (loadPct)  loadPct.textContent  = clamped.toFixed(0) + '%';
  }

  function markReady() {
    if (startBtn) startBtn.classList.add('ready');
    if (loadLabel) loadLabel.textContent = 'Ready';
    setProgress(100);
  }

  // Smooth fake progress
  const fakeTimer = setInterval(function () {
    if (lottieReady) return;
    setProgress(Math.min(92, progress + (progress < 45 ? 2.6 : 1.0)));
    if (loadLabel) {
      loadLabel.textContent = progress < 70 ? 'Loading motion' : 'Finalizing';
    }
  }, 140);

  // Safety: never leave page stuck behind loader
  setTimeout(function () {
    if (startBtn && !startBtn.classList.contains('ready')) {
      if (loadLabel) loadLabel.textContent = 'Start';
      setProgress(100);
      startBtn.classList.add('ready');
    }
  }, 4500);

  // --------------- Lottie loading ---------------
  // Read URLs from data attributes on the section element
  var sectionEl = document.getElementById('sr-homepage-section');
  var desktopLottieUrl = sectionEl ? sectionEl.getAttribute('data-lottie-desktop') : '';
  var mobileLottieUrl  = sectionEl ? sectionEl.getAttribute('data-lottie-mobile') : '';

  var DESKTOP_LOTTIE_CANDIDATES = desktopLottieUrl
    ? [desktopLottieUrl]
    : [
        'animation%20p1.json',
        'animation_p1.json'
      ];

  var MOBILE_LOTTIE_CANDIDATES = mobileLottieUrl
    ? [mobileLottieUrl]
    : DESKTOP_LOTTIE_CANDIDATES;

  var isMobileLottie = window.matchMedia('(max-width: 768px), (pointer: coarse)').matches;
  var LOTTIE_CANDIDATES = isMobileLottie ? MOBILE_LOTTIE_CANDIDATES : DESKTOP_LOTTIE_CANDIDATES;

  function tryLoad(i) {
    if (i >= LOTTIE_CANDIDATES.length) {
      clearInterval(fakeTimer);
      if (loadLabel) loadLabel.textContent = 'Animation not found';
      setProgress(100);
      if (startBtn) startBtn.classList.add('ready');
      console.error('Could not load Lottie JSON. Tried:', LOTTIE_CANDIDATES);
      return;
    }

    var url = LOTTIE_CANDIDATES[i] + (LOTTIE_CANDIDATES[i].indexOf('?') > -1 ? '&' : '?') + 'v=' + Date.now();

    try {
      if (lottieAnim) {
        try { lottieAnim.destroy(); } catch (e) { }
        lottieAnim = null;
      }

      lottieAnim = lottie.loadAnimation({
        container: document.getElementById('sr-lottieHolder'),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: url
      });

      var onDomLoaded = function () {
        lottieReady = true;
        clearInterval(fakeTimer);
        var svg = document.querySelector('#sr-lottieHolder svg');
        if (svg) {
          svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
          svg.style.width = '100%';
          svg.style.height = '100%';
        }
        markReady();
        lottieAnim.removeEventListener('DOMLoaded', onDomLoaded);
      };

      var onError = function () {
        lottieAnim.removeEventListener('DOMLoaded', onDomLoaded);
        lottieAnim.removeEventListener('error', onError);
        lottieAnim.removeEventListener('data_failed', onError);
        tryLoad(i + 1);
      };

      lottieAnim.addEventListener('DOMLoaded', onDomLoaded);
      lottieAnim.addEventListener('error', onError);
      lottieAnim.addEventListener('data_failed', onError);

      setTimeout(function () {
        if (!lottieReady) onError();
      }, 3500);

    } catch (e) {
      tryLoad(i + 1);
    }
  }

  // Start loading Lottie immediately
  if (typeof lottie !== 'undefined') {
    tryLoad(0);
  } else {
    // If Lottie script failed to load, just enable start
    clearInterval(fakeTimer);
    markReady();
  }

  // --------------- Particles ---------------
  var particleBase = {
    background: { color: { value: 'transparent' } },
    fpsLimit: 60,
    detectRetina: true,
    interactivity: {
      events: {
        onHover: { enable: true, mode: 'repulse' },
        onClick: { enable: true, mode: 'push' }
      },
      modes: {
        repulse: { distance: 120, duration: 0.35 },
        push: { quantity: 3 }
      }
    },
    particles: {
      number: { value: 70, density: { enable: true, area: 900 } },
      color: { value: ['#ffffff', '#f7c873', '#ffdf9c', '#5bb7ff'] },
      links: { enable: true, distance: 150, opacity: 0.16, width: 1 },
      move: { enable: true, speed: 0.55, direction: 'none', outModes: { default: 'out' } },
      opacity: { value: 0.36 },
      size: { value: { min: 1, max: 3 } }
    }
  };

  if (typeof tsParticles !== 'undefined') {
    tsParticles.load({ id: 'sr-particles', options: particleBase });
  }

  // --------------- Scroll experience ---------------
  function initScrollExperience() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    var stage = document.getElementById('sr-stage');
    var slots = Array.from(document.querySelectorAll('.sr-slot'));
    var dimEl = document.getElementById('sr-bgDim');

    function clamp01(v) { return Math.max(0, Math.min(1, v)); }

    // Map scroll progress to Lottie frames
    ScrollTrigger.create({
      trigger: stage,
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      onUpdate: function (self) {
        if (!lottieAnim) return;
        var p = clamp01(self.progress);
        var total = lottieAnim.totalFrames || 1;
        var frame = Math.floor(p * (total - 1));
        lottieAnim.goToAndStop(frame, true);

        var glow = 0.20 + p * 0.26;
        var particlesEl = document.getElementById('sr-particles');
        if (particlesEl) {
          particlesEl.style.filter =
            'drop-shadow(0 0 ' + Math.round(18 * glow) + 'px rgba(247,200,115,' + glow.toFixed(2) + '))';
        }
      }
    });

    // Active slot management
    function setActiveSlot(activeEl) {
      slots.forEach(function (el) {
        el.classList.toggle('active', el === activeEl);
      });

      if (dimEl && window.gsap) {
        var scene = activeEl ? activeEl.getAttribute('data-slot') : '1';
        var target = scene === '1' ? 0.42
          : scene === '2' ? 0.34
          : scene === '3' ? 0.28
          : scene === '4' ? 0.24
          : 0.20;
        gsap.to(dimEl, { opacity: target, duration: 0.55, ease: 'power3.out', overwrite: true });
      }
    }

    // Animate slots
    slots.forEach(function (slot, i) {
      var scene = slot.getAttribute('data-slot');
      var start = i * (100 / slots.length);
      var end = (i + 1) * (100 / slots.length);

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: stage,
          start: function () { return 'top+=' + start + '% top'; },
          end: function () { return 'top+=' + end + '% top'; },
          scrub: true,
          onUpdate: function (self) {
            if (self.progress > 0.18 && (scene === '5' ? self.progress <= 1 : self.progress < 0.82)) {
              setActiveSlot(slot);
            }
          }
        }
      });

      tl.to(slot, { opacity: 1, scale: 1, ease: 'power2.out', duration: 0.35 }, 0)
        .to(slot, { opacity: 1, scale: 1, duration: 0.30 }, 0.20);

      if (scene !== '5') {
        tl.to(slot, { opacity: 0, scale: 0.98, ease: 'power2.in', duration: 0.35 }, 0.74);
      } else {
        tl.to(slot, { opacity: 1, scale: 1, duration: 0.35 }, 0.74);
      }

      // Scene-specific animations
      if (scene === '1') {
        tl.fromTo('#sr-s1whisper', { opacity: 0, y: 10 }, { opacity: 0.95, y: 0, duration: 0.22 }, 0.08);
        tl.fromTo('#sr-s1expand', { opacity: 0, y: 26, scale: 0.95 }, { opacity: 1, y: 0, scale: 1, duration: 0.28 }, 0.12);
        tl.to('#sr-s1expand', { scale: 1.12, letterSpacing: '-0.03em', duration: 0.40 }, 0.30);
        tl.fromTo('#sr-s1sub', { opacity: 0, y: 14 }, { opacity: 0.9, y: 0, duration: 0.25 }, 0.18);
      }

      if (scene === '2') {
        tl.fromTo('.sr-scene2Wrap', { y: 26, opacity: 0, scale: 0.98 }, { y: 0, opacity: 1, scale: 1, duration: 0.32 }, 0.12);
        tl.fromTo('.sr-scene2Item', { opacity: 0, y: 10 }, { opacity: 1, y: 0, stagger: 0.05, duration: 0.22 }, 0.22);
        tl.fromTo('#sr-scene2Brand', { opacity: 0, y: 10, scale: 0.98 }, { opacity: 1, y: 0, scale: 1, duration: 0.22 }, 0.18);
      }

      if (scene === '3') {
        tl.fromTo('#sr-s3big', { opacity: 0, y: 34 }, { opacity: 1, y: 0, duration: 0.26 }, 0.12);
        tl.fromTo('#sr-s3p', { opacity: 0, y: 18 }, { opacity: 0.95, y: 0, duration: 0.22 }, 0.18);
      }

      if (scene === '4') {
        tl.fromTo('#sr-s4left', { opacity: 0, x: -26 }, { opacity: 1, x: 0, duration: 0.28 }, 0.14);
        tl.fromTo('#sr-s4right', { opacity: 0, x: 26 }, { opacity: 1, x: 0, duration: 0.28 }, 0.18);
      }

      if (scene === '5') {
        tl.fromTo('.sr-final', { opacity: 0, y: 30, scale: 0.98 }, { opacity: 1, y: 0, scale: 1, duration: 0.30 }, 0.12);
      }
    });

    // CTA buttons
    document.getElementById('sr-ctaBtn')?.addEventListener('click', function () {
      window.location.href = sectionEl ? (sectionEl.getAttribute('data-builder-url') || '/pages/builder') : '/pages/builder';
    });
    document.getElementById('sr-ctaBtn2')?.addEventListener('click', function () {
      window.location.href = sectionEl ? (sectionEl.getAttribute('data-builder-url') || '/pages/builder') : '/pages/builder';
    });
    document.getElementById('sr-ctaBtn3')?.addEventListener('click', function () {
      window.location.href = sectionEl ? (sectionEl.getAttribute('data-builder-url') || '/pages/builder') : '/pages/builder';
    });

    // Replay buttons
    document.getElementById('sr-replayBtn')?.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.getElementById('sr-replayBtn2')?.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Timeline highlight (Scene 3)
    var timelineStepsEl = document.getElementById('sr-timelineSteps');
    var timelineStepLabel = document.getElementById('sr-timelineStep');
    if (timelineStepsEl && window.ScrollTrigger) {
      var steps = Array.from(timelineStepsEl.querySelectorAll('.sr-tStep'));
      ScrollTrigger.create({
        trigger: document.querySelector('.sr-slot[data-slot="3"]'),
        start: 'top center',
        end: 'bottom center',
        scrub: true,
        onUpdate: function (self) {
          var p = Math.max(0, Math.min(1, self.progress));
          var idx = Math.max(0, Math.min(steps.length - 1, Math.floor(p * steps.length)));
          steps.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
          if (timelineStepLabel) timelineStepLabel.textContent = 'Step ' + (idx + 1) + ' of ' + steps.length;
        }
      });
    }

    // Scene 2 brand logo animation
    var scene2Brand = document.getElementById('sr-scene2Brand');
    if (scene2Brand && window.ScrollTrigger) {
      gsap.to(scene2Brand, {
        opacity: 1, y: 0, scale: 1,
        duration: 0.6, ease: 'power3.out',
        scrollTrigger: {
          trigger: document.querySelector('.sr-slot[data-slot="2"]'),
          start: 'top 65%',
          end: 'bottom 35%',
          toggleActions: 'play reverse play reverse'
        }
      });
    }

    ScrollTrigger.refresh();
  }

// --------------- Auto-start (no loader gate) ---------------
function autoStartExperience() {
  if (bgDim && window.gsap) {
    gsap.to(bgDim, { opacity: 0.42, duration: 0.55, ease: 'power3.out', overwrite: true });
  }
  if (loaderEl) {
    loaderEl.style.display = 'none';
    loaderEl.classList.add('hide');
  }
  document.body.classList.remove('locked');
  try { window.scrollTo({ top: 0, behavior: 'auto' }); } catch (e) { window.scrollTo(0, 0); }
  initScrollExperience();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(autoStartExperience, 100);
  });
} else {
  setTimeout(autoStartExperience, 100);
}

if (startBtn) {
  startBtn.addEventListener('click', autoStartExperience);
}

})();
